import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import HotDeals from "../components/HotDeals";
import BottomFooter from "../../../shared/layout/BottomFooter";
import Footer from "../../../shared/layout/Footer";
import { CartProvider } from "../../cart/context/CartContext";

const HotDealsPage = () => {
    return (
        
        <CartProvider>
    
        <ColorInit color={'bigmall'} />
    
        <ScrollToTop smooth color='#ef253c' />
    
    
        <Header />
        <div className="container container-lg">
        <HotDeals />
        </div>
        <Footer />
    
        <BottomFooter />
        </CartProvider>
        
    );
    };

export default HotDealsPage;